module.exports = __webpack_public_path__ + "img/wenhua.3e2a7116.png";